import { Box, IconButton } from '@material-ui/core';

import { Text } from '@/components/shared/components/Text';

import { useCustomTheme } from '../../../../../../../../hooks/useCustomTheme';
import { Font } from '../../../../../../../shared/components/Font';
import { IconHeader } from '../../../../../../../shared/components/IconHeader';
import { NewAgent } from '../types/NewAgent';

interface AgentCardProps {
  agent: NewAgent;
  removeAgent?: (agent: NewAgent) => void;
}

export const AgentCard = ({ agent, removeAgent }: AgentCardProps) => {
  const { palette, customBorderRadius } = useCustomTheme();
  return (
    <Box py={1} px={2} mt={2} key={agent.agentId} bgcolor={palette.grey[50]} borderRadius={customBorderRadius.paper}>
      <Box display={'flex'} alignItems={'center'} justifyContent={'space-between'} my={1}>
        <Box display={'flex'} alignItems={'center'}>
          <IconHeader iconName={'account_circle'} color={'minor'} />
          <Box ml={2} display={'flex'} flexDirection={'column'}>
            <Font variant={'body2'} color={'title'}>
              <strong>{agent.agentName}</strong> <Text tId={'IN'} /> {agent.channelDescription}
            </Font>
            {agent.agentEmail && (
              <Font variant={'caption'} color={'textSecondary'}>
                {agent.agentEmail}
              </Font>
            )}
          </Box>
        </Box>
        {removeAgent && (
          <IconButton size={'small'} className={'ml-2'} onClick={() => removeAgent(agent)}>
            <i className={'material-icons-outlined'}>delete</i>
          </IconButton>
        )}
      </Box>
    </Box>
  );
};
